import React from "react";
import { connect } from "react-redux";
import Axios from "Source/axiosPool";
import Select from "Components/common/Select/Select";
import Avatar from "Components/common/Avatar/Avatar";
import _  from 'lodash';

@connect(store => {
    return {
        project: store.project,
        loggedUser: store.loggedUser
    }
})

class FieldTemplates extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            workstreams: [],
            searchIsLoading: false
        }

        _.map(["onOpen", "onRenderOption", "onRenderSelected", "onChange"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    handleSearchWorkstream = _.debounce((workstreamName = null) => {
        const url = "api/workstream";
        const params = {
            isActive: 1,
            isTemplate: 1,
            ...(workstreamName && {
                workstream: workstreamName
            })
        };

        this.setState({
            ...this.state,
            searchIsLoading: true
        });

        Axios.get(url, params)
            .then(response => {
                if( response.data ) {
                    this.setState({
                        ...this.state,
                        searchIsLoading: false,
                        workstreams: response.data.result.map(u => ({
                            value: u.id,
                            label: u.workstream,
                            workstream: u
                        }))
                    });
                }
            });
    }, 400);

    
    onOpen() {
        if( this.props.onLeadOpen ) {
            this.setState({
                ...this.state,
                searchIsLoading: true
            });

            this.props.onLeadOpen();
        }

        this.handleSearchWorkstream();
    }

    onRenderOption(option) {
        const { project } = this.props;

        return (
            <div class="lead-option">
                <div class="lead-container">
                    <span>{option.label}</span>
                    <span>{option.workstream.project.project}</span>
                </div>
            </div>
        )
    }

    onRenderSelected(option) {
        const { project } = this.props;

        return (
            <div class="lead-option">
                <div class="lead-container">
                    <span>{option.label} ({option.workstream.project.project})</span>
                </div>
            </div>
        )
    }

    onChange(option) {
        if( this.props.onChange ) {
            this.props.onChange( option.workstream );
        }
    }

    render() {
        return (
            <Select 
                isSearchable={true}
                classes={{options: `addUsersOption templateOption`}}
                placeholder="Select"
                options={this.state.workstreams}
                onChange={this.onChange}
                onSearch={this.handleSearchWorkstream}
                onClearSelected={this.props.onChange}
                onOpen={this.onOpen}
                isLoading={this.state.searchIsLoading}
                isClose={this.props.isClose}
                selected={this.props.selected}
                count={10}
                renderOption={this.onRenderOption}
                renderSelected={this.onRenderSelected}
                isFirstItemSelected={false}
                searchIcon={<i class="material-icons">search</i>}
            />
        );
    }
}

export default FieldTemplates;
